import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

@Component({
  selector: 'ebb-portal-loading',
  templateUrl: './loading.component.html',
  styles: []
})
export class LoadingComponent implements OnInit  {
  constructor(
    private readonly router: Router,
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.router.navigate(['home']);
    }, 500);
  }

}
